import { useMutation } from "@tanstack/react-query";
import { createKPIReview, CreateKPIReviewPayload } from "PFCore/services/kpi/create_kpi_review";
import { MutationOptions } from "PFCore/types";

import { engagementsKeys } from "../engagements/query_keys";
import { KPIMutationKeys } from "./kpi_mutation_keys";
import { KPIKeys } from "./query_keys";

export const useKPIReviewCreate = (options: MutationOptions<CreateKPIReviewPayload> = {}) =>
  useMutation<void, any, CreateKPIReviewPayload>({
    mutationKey: KPIMutationKeys.reviewCreate(),
    mutationFn: (payload) => createKPIReview(payload),
    meta: {
      invalidation: {
        replace: true,
        composeQueryKeys: (_, { indicatorId, engagementId }) => [
          KPIKeys.kpiResult(engagementId, indicatorId),
          KPIKeys.kpiResults(engagementId),
          KPIKeys.kpiEvents(engagementId, { indicatorId }),
          engagementsKeys.all()
        ]
      }
    },
    ...options
  });
